<template>
  <iframe style="width: 100%; height: 100%"
          @load="load"
          :src="src"
          ref="iframeDom"
          frameborder="0"></iframe>
</template>

<script>
export default {
  data () {
    return {
      key: 'e164e4ee-a42f-4c9b-937e-a4d8a315f6c0'
    }
  },
  computed: {
    src () {
      return this.$store.state.settings.iframeUrl + '&vvvvv=' + new Date().getTime()
    }
  },

  methods: {
    load (e) {
      var MPSDK = window.MP_SDK || e.target.contentWindow.MP_SDK
      try {
        MPSDK.connect(e.target, this.key || 'e164e4ee-a42f-4c9b-937e-a4d8a315f6c0', '3.2')
          .then(async (sdk) => {
            this.$emit('ready', sdk)
            window.sdk = sdk
          })
          .catch((e) => {
            console.error(e)
          })
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
iframe{
 width: 100vw;
 height: 100vh;
 overflow: hidden;
}
</style>
